import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { formatDateTime } from "@madmedical/utils";
import { Box, Text } from "native-base";
import { Pressable } from "react-native";
import { useTranslation } from "@madmedical/i18n";
import ReactTable from "../molecules/ReactTable";
import ActionButton from "../molecules/ActionButton";
import { formatInsertPoint, formatType } from "../util/insulinFormatters";
import { InsulinQuantityListItem } from "../molecules/ListItem/InsulinQuantityListItem";
const pressableStyle = {
    maxWidth: "100%",
};
const InsulinMeasurementsTable = ({ data, onEndReached, onDeletePress, onEditPress, pressLink, }) => {
    const LinkWrapper = useCallback(({ children }) => pressLink ? (_jsx(Pressable, Object.assign({ onPress: pressLink, style: pressableStyle }, { children: children }))) : (_jsx(_Fragment, { children: children })), [pressLink]);
    const { t } = useTranslation();
    const columns = useMemo(() => [
        {
            Header: t("appointment"),
            accessor: "administeredAt",
            width: "100px",
            minWidth: 90,
            Cell: ({ value }) => value ? (_jsx(LinkWrapper, { children: _jsx(Text, { children: formatDateTime(value) }) })) : (_jsx(LinkWrapper, { children: _jsx(Box, { children: "-" }) })),
        },
        {
            Header: "Mennyiség",
            accessor: "units",
            width: "60px",
            Cell: ({ value, row }) => {
                var _a, _b, _c, _d;
                return value && ((_b = (_a = row.original) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.type) ? (_jsx(LinkWrapper, { children: _jsx(InsulinQuantityListItem, { units: value, type: (_d = (_c = row.original) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.type }) })) : (_jsx(LinkWrapper, { children: _jsx(Box, { children: "-" }) }));
            },
        },
        {
            Header: t("type"),
            accessor: (data) => data.product.type,
            width: "100px",
            minWidth: 25,
            Cell: ({ value }) => value ? (_jsx(LinkWrapper, { children: _jsx(Text, Object.assign({ isTruncated: true }, { children: formatType(value) })) })) : (_jsx(LinkWrapper, { children: _jsx(Box, { children: "-" }) })),
        },
        {
            Header: "Termék neve",
            accessor: (data) => data.product.name,
            width: "200px",
            minWidth: 70,
            Cell: ({ value }) => (_jsx(LinkWrapper, { children: _jsx(Text, { children: value }) })),
        },
        {
            Header: "Beadási hely",
            accessor: "bodyLocation",
            width: "15%",
            minWidth: 70,
            Cell: ({ value }) => {
                if (value) {
                    const { bodyPart, side } = value;
                    if (!bodyPart || !side)
                        return (_jsx(LinkWrapper, { children: _jsx(Box, { children: "-" }) }));
                    return (_jsx(LinkWrapper, { children: _jsx(Text, { children: formatInsertPoint(bodyPart, side) }) }));
                }
                return (_jsx(LinkWrapper, { children: _jsx(Box, { children: "-" }) }));
            },
        },
        {
            Header: t("comment"),
            accessor: "comment",
            width: "20%",
            Cell: ({ value }) => (_jsx(LinkWrapper, { children: _jsx(Text, { children: value }) })),
        },
        {
            Header: "",
            id: "action",
            width: 40,
            Cell: ({ row: { original: measurement }, }) => (_jsx(Box, Object.assign({ flexDirection: "row", justifyContent: "flex-end", w: "full" }, { children: _jsx(ActionButton, { size: "xs", actions: (measurement === null || measurement === void 0 ? void 0 : measurement.editable)
                        ? [
                            {
                                text: t("edit"),
                                iconName: "edit",
                                onPress: () => {
                                    onEditPress === null || onEditPress === void 0 ? void 0 : onEditPress(measurement);
                                },
                            },
                            {
                                text: t("delete"),
                                iconName: "trashCan",
                                onPress: () => {
                                    onDeletePress === null || onDeletePress === void 0 ? void 0 : onDeletePress(measurement.id);
                                },
                            },
                        ]
                        : [] }) }))),
        },
    ], [onEditPress, onDeletePress, LinkWrapper, t]);
    return (_jsx(ReactTable, { columns: columns, data: data, onEndReached: onEndReached }));
};
export default InsulinMeasurementsTable;
